var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #003c71;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192,64c-35.3,0-64,28.7-64,64v384c0,35.3,28.7,64,64,64h256c35.3,0,64-28.7,64-64V234.5c0-17-6.7-33.3-18.7-45.3l-106.6-106.5c-12-12-28.2-18.7-45.2-18.7h-149.5ZM453.5,240h-93.5c-13.3,0-24-10.7-24-24v-93.5l117.5,117.5ZM192,448v-64c0-17.7,14.3-32,32-32h192c17.7,0,32,14.3,32,32v64c0,17.7-14.3,32-32,32h-192c-17.7,0-32-14.3-32-32ZM216,128h48c13.3,0,24,10.7,24,24s-10.7,24-24,24h-48c-13.3,0-24-10.7-24-24s10.7-24,24-24ZM216,224h48c13.3,0,24,10.7,24,24s-10.7,24-24,24h-48c-13.3,0-24-10.7-24-24s10.7-24,24-24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtc);
export default __webpack_public_path__ + "static/media/DTC.698c9b94e1a5daa62b6efcb865f743d0.svg";
export { ForwardRef as ReactComponent };